"use client";
import { FC, useEffect, useState } from "react";
import { wipEN } from "@/assets/dictionaries/en/wip-content";
import { wipES } from "@/assets/dictionaries/es/wip-content";

const WIP: FC = () => {
  const [wipContent, setWipContent] = useState(wipEN); // Default to English

  useEffect(() => {
    // Get the language from localStorage
    const lang = localStorage.getItem("selectedOption") || "EN"; // Default to EN if not found

    // Set the content based on the language
    switch (lang.toUpperCase()) {
      case "ES":
        setWipContent(wipES);
        break;
      case "EN":
      default:
        setWipContent(wipEN);
        break;
    }
  }, []); // Only run on mount

  return (
    <div className="min-h-screen">
      <div className="flex flex-col items-center justify-center min-h-screen">
        <h1 className="text-4xl font-bold">{wipContent.wip_title}</h1>
        <p className="text-xl">{wipContent.wip_desc_1}</p>
        <p className="text-xl">{wipContent.wip_desc_2}</p>
      </div>
    </div>
  );
};

export default WIP;
